import {
  Alert,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useCategories } from './useProductCategoryData'
import './CategoriesTab.css'

export function CategoriesTab() {
  const { categories, error } = useCategories()

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        This list is read from NetSuite. Edit it in NetSuite and changes show up here within 10 minutes.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Category</TableCell>
              <TableCell>Assignable</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map(category => (
              <TableRow key={category.fullName}>
                <TableCell className={category.parentName ? 'categories-tab-child' : 'categories-tab-parent'}>
                  {category.fullName}
                </TableCell>
                <TableCell>{category.isLeaf ? 'Yes' : 'Group'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}
